import { post } from "./base.service";

async function getPowerBIEmbedToken({ request }) {
  return await post(`/WebApi/Invoke`, {
    ActionVerb: "GET",
    ControllerName: "PowerBI",
    ActionName: "GetEmbedPowerBIToken",
    QueryString:
      "userName=" + request.username + `&` + "moduleName=" + request.module,
    Data: "",
  });
}

export { getPowerBIEmbedToken };
